import { isContainedInList } from "helpers/row-logic-helper";
import { AMORTIZATION_TYPES } from "@loanbossinc/component-library";
import interestRateTypeIds from "constants/interestRateTypes";

// thoe row will show for STRAIGHTLINE in the UI however it is actually the STRAIGHT_LINE_CUSTOM_AMORT guid
export const shouldShowPrincipalReduction = extension => isContainedInList(extension, "extensionAmortizationTypeId", [AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT]);

export const shouldShowAmortizationTerm = extension => isContainedInList(extension, "extensionAmortizationTypeId", [AMORTIZATION_TYPES.MORTGAGE_STYLE, AMORTIZATION_TYPES.AGENCY_FLOATER]);

export const shouldShowAmortizationRate = (extension, loan) => {
  const rateTypeId = loan ? loan.rateTypeId : extension.rateTypeId;

  return rateTypeId === interestRateTypeIds.FLOATING &&
  isContainedInList(extension, "extensionAmortizationTypeId", [AMORTIZATION_TYPES.MORTGAGE_STYLE]);
};
